import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'kkk-logo',
    templateUrl: './logo.component.html'
})
export class LogoComponent implements OnInit {
    static WIDTH: number = 504;
    static HEIGHT: number = 558;

    @Input() width: number;
    @Input() height: number;
    @Input() cssClass: string;

    private _width: number;
    private _height: number;
    private _widthScale: number;
    private _heightScale: number;

    constructor() { }

    ngOnInit() {
        this.initWidth();
        this.initHeight();
        this.scale();
    }

    private initWidth() {
        if (isNaN(+this.width)) {
            this._width = LogoComponent.WIDTH;
            this._widthScale = 1;
        } else {
            this._width = +this.width;
            this._widthScale = this._width / LogoComponent.WIDTH;
        }
    }

    private initHeight() {
        if (isNaN(+this.height)) {
            this._height = LogoComponent.HEIGHT;
            this._heightScale = 1;
        } else {
            this._height = +this.height;
            this._heightScale = this._height / LogoComponent.HEIGHT;
        }
    }

    private scale() {
        if (this._widthScale === this._heightScale || (this._widthScale !== 1 && this._heightScale !== 1)) {
            return;
        }
        this._width = this._width * this._heightScale;
        this._height = this._height * this._widthScale;
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/logo/logo.component.ts